const STATUS_CHIP_SX = {
    success: { bgcolor: '#e8f5e9', color: '#2e7d32' },
    error: { bgcolor: '#fde8e8', color: '#c62828' },
    warning: { bgcolor: '#fff3e0', color: '#e65100' },
    info: { bgcolor: '#e3f2fd', color: '#01579b' },
    primary: { bgcolor: '#e3f4fc', color: '#0550a0' },
    accent: { bgcolor: '#fff9c4', color: '#827717' },
    default: {},
};
export function getStatusChipSx(color) {
    return STATUS_CHIP_SX[color] ?? {};
}
export function getMigrationStatusColor(status) {
    switch (status) {
        case 'success':
            return 'success';
        case 'failed':
        case 'deleted':
            return 'error';
        case 'notReady':
        case 'skipped':
            return 'warning';
        case 'started':
        case 'inprogress':
            return 'info';
        default:
            return 'default';
    }
}
export function getValidationStatusColor(status) {
    switch (status) {
        case 'success':
            return 'success';
        case 'failed':
            return 'error';
        case 'inprogress':
        case 'started':
            return 'info';
        case 'skipped':
        case 'warn':
            return 'warning';
        default:
            return 'default';
    }
}
export function getRollbackStatusColor(status) {
    switch (status) {
        case 'success':
            return 'success';
        case 'failed':
            return 'error';
        case 'started':
            return 'info';
        default:
            return 'default';
    }
}
export function getDatafixStatusColor(status) {
    switch (status) {
        case 'success':
            return 'accent';
        case 'failed':
            return 'error';
        default:
            return 'default';
    }
}
export function getHubDataStatusColor(status) {
    switch (status) {
        case '2.0.0':
            return 'success';
        case 'ceEnabled':
            return 'primary';
        default:
            return 'default';
    }
}
const BATCH_STATUS_LABELS = {
    created: 'Created',
    closed: 'Closed',
    hubSyncStarted: 'Hub Sync Started',
    migrationScheduling: 'Scheduling Migration',
    migrationScheduleFailed: 'Schedule Failed',
    migrationStarted: 'Migrating',
    migrationCompleted: 'Migration Done',
    validationScheduling: 'Scheduling Validation',
    validationScheduleFailed: 'Validation Schedule Failed',
    validationStarted: 'Validating',
    validationCompleted: 'Validation Done',
    rollbackStarted: 'Rolling Back',
    rollbackSuccess: 'Rollback Done',
    rollbackFailed: 'Rollback Failed',
};
export function getBatchStatusColor(status) {
    switch (status) {
        case 'migrationCompleted':
        case 'validationCompleted':
            return 'success';
        case 'rollbackFailed':
        case 'migrationScheduleFailed':
        case 'validationScheduleFailed':
            return 'error';
        case 'rollbackSuccess':
        case 'migrationScheduling':
        case 'validationScheduling':
            return 'warning';
        case 'hubSyncStarted':
        case 'migrationStarted':
        case 'validationStarted':
        case 'rollbackStarted':
            return 'info';
        default:
            return 'default';
    }
}
export function getBatchStatusLabel(status) {
    return BATCH_STATUS_LABELS[status] ?? status;
}
export const JOB_STATUS_COLOR_MAP = {
    scheduled: 'default',
    started: 'info',
    success: 'success',
    warning: 'warning',
    failed: 'error',
    cancelled: 'default',
};
export function getJobStatusChipSx(status) {
    return getStatusChipSx(JOB_STATUS_COLOR_MAP[status] ?? 'default');
}
